<div class="modal-header">
  <h4 class="modal-title"> {{popupLabel | translate}} </h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">

    <p class="mb-4" [innerHTML]="'editDrillingHolePopup.label.notice.saftey' | translate"></p>

      <b class="d-block mb-3" id="rail-length-text">{{ totalRailLengthLabel }}</b>

    <div class="row justify-content-center mb-4">
      <img *ngIf="currentMode === EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE" src="../../../../../../ng-assets/pics/drilling_hole/mounting_rail_wizard.png">
      <img *ngIf="currentMode !== EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE" src="../../../../../../ng-assets/pics/drilling_hole/mounting_rail_edit.png">
    </div>

    <form class="mb-2" [formGroup]="form">
      <div class="row">
        <div class="col-4">
          <label for="startOffset">{{'editDrillingHolePopup.label.start_position' | translate}}</label>
        </div>
        <div class="col-4" *ngIf="currentMode === EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE">
          <label for="holeCount">{{'editDrillingHolePopup.label.count' | translate}}</label>
        </div>
        <div class="col-4" *ngIf="currentMode === EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE">
          <label for="endOffset">{{'editDrillingHolePopup.label.end_position' | translate}}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <input type="text" class="form-control" id="startOffset"
            formControlName="startOffset"
            inputRestricter="^-?[0-9\.,]*$"
            (inputEvent)="startOffsetInputEventHandler($event)"
            [readonly]="!(currentMode === EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE || !carrierHasPreset)"
            [class.is-invalid]="form.controls.startOffset.invalid">
          <div class="invalid-feedback">
            {{ form.controls.startOffset.errors?.messageKey | translate:{'0':form.controls.startOffset.errors?.param} }}
          </div>
        </div>
        <div class="col-4" *ngIf="currentMode === EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE">
          <input type="text" class="form-control" id="holeCount"
            inputRestricter="^[0-9]*$"
            [readonly]="carrierHasPreset"
            formControlName="holeCount"
            [readonly]="carrierHasPreset || holeCountInputDisabled"
            [class.is-invalid]="form.controls.holeCount.invalid">
          <div class="invalid-feedback">
            {{ form.controls.holeCount.errors?.messageKey | translate:{'0':form.controls.holeCount.errors?.param} }}
          </div>
        </div>
        <div class="col-4" *ngIf="currentMode === EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE">
          <input type="text" class="form-control" id="endOffset"
            formControlName="endOffset"
            inputRestricter="^-?[0-9\.,]*$"
            (inputEvent)="endOffsetInputEventHandler($event)"
            [readonly]="endOffsetInputDisabled"
            [class.is-invalid]="form.controls.endOffset.touched && form.controls.endOffset.invalid">
          <div class="invalid-feedback">
            {{ form.controls.endOffset.errors?.messageKey | translate:{'0':form.controls.endOffset.errors?.param} }}
          </div>
        </div>
      </div>
    </form>

    <div class="mb-2">
      <b class="d-block mb-3">{{'editDrillingHolePopup.label.shape_type' | translate}}</b>
      <div class="hole-type mb-4" [ngClass]="shapeTypes?.length > 1 ? 'justify-content-around' : 'mx-0'">
        <div class="form-check form-check-inline" *ngFor="let shapeType of shapeTypes">
          <input class="form-check-input" type="radio" name="holeTypes" [id]="shapeType" [value]="shapeType"
            [(ngModel)]="selectedType" [disabled]="carrierHasPreset" (change)="shapeRadioButton_changeHandler()">
          <label class="form-check-label" [for]="shapeType">
            <i class="d-block" [ngClass]="shapeType" [class.unselected]="selectedType !== shapeType"></i>
          </label>
        </div>
      </div>
    </div>

    <div class="mb-2">
      <b class="d-block mb-1">{{'editDrillingHolePopup.label.country' | translate}}</b>
      <div>
        <div>
          <select class="form-control" [(ngModel)]="selectedProductionCountry" id="productionCountryDropDownList"
            name="productionCountryDropDownList" [disabled]="carrierHasPreset">
            <option *ngFor="let country of productionCountries" [ngValue]="country">
              {{country.name}}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="mb-2">
      <b class="d-block mb-1">{{'editDrillingHolePopup.label.size' | translate}}</b>
      <div>
        <div>
          <select class="form-control" id="sizeDropDownList" name="sizeDropDownList" [(ngModel)]="selectedSize" [disabled]="carrierHasPreset">
            <option [ngValue]="null" [selected]="!selectedSize">{{'editDrillingHolePopup.prompt.select_size' | translate}}</option>
            <option *ngFor="let size of shapeTypeMap.getValue(selectedType)" [ngValue]="size">
              {{getSizeDropDownLabel(size)}}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div *ngIf="currentMode !== EditDrillingHoleMode.DRILLING_HOLE_WIZARD_MODE">
      <b class="d-block mb-1">{{'editDrillingHolePopup.label.accessory' | translate}}</b>
      <div class="mb-2" *ngFor="let accessoryList of accessoryLists">
        <div>
          <select data-testid="drilling-hole-accesorie-selection" class="form-control" [disabled]="!accessoryDropDownListEnabled" [(ngModel)]="accessoryList.selectedItem"
            (change)="accessoryDropDownListchangeHandler()">
            <option [ngValue]="null" [selected]="!accessoryList.selectedItem">{{'editDrillingHolePopup.prompt.select_accessory' | translate}}</option>
            <option *ngFor="let accessory of accessoryList.items" [ngValue]="accessory">
              {{getAccessoryDropDownLabel(accessory)}}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button id="button-cancel" type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{ 'global.label.cancel' | translate }}
  </button>
  <button id="button-accept" type="submit" class="btn btn-primary btn-forward" [disabled]="!selectedType || !selectedSize || form.invalid" (click)="save()">
    {{'global.label.accept' | translate}}
  </button>
</div>
